import React, { useState } from 'react';
import { FaPlus, FaMinus, FaTrash, FaRegEdit, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { BASE_URL } from '../../../../BaseUrl';
import { currencySymbolLeft } from '../../../../functions/Functions';

const SidebarCartItem = ({ item, onAddToCart, onRemoveFromCart, onEditInstruction, showImage = true }) => {
  const [isAddonsOpen, setIsAddonsOpen] = useState(false);

  return (
    <div className="cart-item-card bg-white p-2 rounded-lg shadow-sm mb-2 d-flex align-items-center border gap-3" style={{ borderColor: '#e2e8f0', transition: 'all 0.2s ease' }}>
      {showImage && <img src={item.image ? BASE_URL + item.image : "/assets/img/default-item.jpeg"} onError={(e) => { e.target.onerror = null; e.target.src = "/assets/img/default-item.jpeg" }}
       alt={item.name} className="rounded" style={{ width: '65px', height: '65px', objectFit: 'cover' }} />
      }
      <div className="flex-grow-1 mx-2">
        {/* Removed text-truncate to show full item name */}
        <div className="sidebar-item-name" style={{ color: 'var(--text-primary)' }}>{item.name}</div>
        <div className="text-muted font-weight-md sidebar-item-price">{currencySymbolLeft()} {item.sub_total}</div>
        {item.comments && <div className="text-truncate sidebar-note-text" style={{ color: 'var(--accent-color)' }}>{item.comments}</div>}
        
        {item.properties && item.properties.length > 0 && (
          <div className="mt-2">
            <div 
              className="d-flex align-items-center sidebar-addons-toggle" 
              onClick={() => setIsAddonsOpen(!isAddonsOpen)}
            >
              View Add-ons <span className={`ml-1 sidebar-addons-icon ${isAddonsOpen ? 'open' : ''}`}><FaChevronDown /></span>
            </div>
            
            <div className={`sidebar-addon-container ${isAddonsOpen ? 'open' : ''}`}>
              {item.properties.map((prop, idx) => (
                <div key={idx} className="sidebar-addon-item">
                  <span className="sidebar-addon-qty">{prop.quantity}x</span>
                  <span className="text-muted sidebar-addon-name">{prop.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="d-flex flex-column align-items-end gap-1">
        <div className="d-flex align-items-center border rounded-pill overflow-hidden shadow-sm bg-white sidebar-qty-pill">
          <button className="btn btn-sm bg-white border-0 sidebar-qty-btn" onClick={() => onRemoveFromCart(item)}>
            {item.quantity === 1 ? <FaTrash className="sidebar-qty-icon" /> : <FaMinus className="sidebar-qty-icon" />}
          </button>
          <span className="font-weight-md bg-white sidebar-qty-text">
            {item.quantity}
          </span>
          <button className="btn btn-sm border-0 sidebar-qty-btn-plus" onClick={() => onAddToCart(item, item.variation, item.properties)}>
            <FaPlus className="sidebar-qty-icon-plus" />
          </button>
        </div>
        <button 
          className="btn btn-sm d-flex align-items-center text-muted border-0 bg-transparent hover-accent sidebar-note-btn"
          onClick={() => onEditInstruction(item)}
        >
          <FaRegEdit style={{ marginRight: "2px" }} /> {item.comments ? 'Edit' : 'Add Note'}
        </button>
      </div>
    </div>
  );
};

export default SidebarCartItem;
